import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import AgentHome from './Index.vue';
import { laisCanonicalRedirect } from '../../laisRouteHelpers';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agents'),
      alias: [
        frontendURL('accounts/:accountId/agents'),
        frontendURL('accounts/:accountId/agentes'),
        frontendURL('accounts/:accountId/acessos'),
      ],
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: laisCanonicalRedirect('agent_list'),
        },
        {
          path: 'list',
          name: 'agent_list',
          component: AgentHome,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_MANAGEMENT,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
